<template>
  <el-dialog
    title="采购单"
    :visible.sync="visible"
    width="850px"
    @close="$emit('update:show', false)"
    v-if="model"
  >
    <div class="flex-row-between">
      <div class="number">
        <span>{{ model.number }}</span>
        <br />
        <span class="text-info-12"
          >{{ model.user.name }} {{ formatTime(model.created_at) }}</span
        >
      </div>
      <span>
        <el-popconfirm
          title="确认提交审批吗？"
          @confirm="confirmApprove()"
          v-if="model.status == 1 || model.status == 5"
        >
          <el-button slot="reference" size="mini" type="primary" plain
            >提交审批</el-button
          >
        </el-popconfirm>
        <el-button
          size="mini"
          type="primary"
          plain
          @click="handleApprove()"
          v-if="model.status == 3"
          >审批</el-button
        >
        <template v-if="model.status <= 5">
          <el-button size="mini" type="primary" plain @click="edit()"
            >编辑</el-button
          >
          <el-popconfirm title="确认删除吗？" @confirm="confirmDelte()">
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm></template
        >
      </span>
    </div>
    <ul class="details mt-10">
      <li>
        <span class="title">备注：</span>
        <span>{{ model.remark }}</span>
      </li>
      <li>
        <span class="title">产品明细：</span>
        <div style="flex: 1">
          <el-table :data="model.items" v-if="model">
            <el-table-column label="对象" width="60px">
              <template slot-scope="scope">{{
                scope.row.item.category == 1 ? '零件' : '设备'
              }}</template>
            </el-table-column>
            <el-table-column
              prop="item.name"
              label="名称"
              min-width="250px"
            ></el-table-column>
            <el-table-column
              prop="item.part_number"
              label="件号"
              min-width="120px"
            ></el-table-column>
            <el-table-column
              prop="item.machine_type"
              label="机型"
              min-width="120px"
            ></el-table-column>
            <el-table-column label="单价" width="80">
              <template slot-scope="scope">{{
                scope.row.price.toFixed(2)
              }}</template>
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="80"
            ></el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
  </el-dialog>
</template>

<script>
import { formatTime } from '@/util/index'
import {
  deleteShippingRecord,
  deletePurchaseOrder,
  purchaseOrderStatusChange,
} from '../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      formatTime,
      visible: this.show,
    }
  },
  methods: {
    edit() {
      this.$emit('edit', this.model)
      this.visible = false
    },
    handleApprove(item, index) {
      let that = this
      this.$confirm('请选择审核结果', '提示', {
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        center: true,
      })
        .then(() => {
          purchaseOrderStatusChange({
            id: that.model.id,
            status: 7,
          }).then((res) => {
            that.model.status = res.data.status
            that.$emit('updated', res.data)
            that.visible = false
          })
        })
        .catch(() => {
          purchaseOrderStatusChange({
            id: that.model.id,
            status: 5,
          }).then((res) => {
            that.model.status = res.data.status
            that.$emit('updated', res.data)
            that.visible = false
          })
        })
    },
    async confirmApprove() {
      let res = await purchaseOrderStatusChange({
        id: this.model.id,
        status: 3,
      })
      if (res.code == 0) {
        this.model.status = res.data.status
        this.$emit('updated', res.data)
        this.visible = false
      }
    },
    async confirmDelte() {
      let res = await deletePurchaseOrder(this.model.id)
      if (res.code == 0) {
        this.$emit('deleted', this.model)
        this.visible = false
      }
    },
  },
}
</script>

<style scoped>
.number {
  font-size: 16px;
}
.details li {
  padding: 8px 0;
  display: flex;
}

.details li .title {
  width: 80px;
}

.title {
  color: #888;
}
</style>